import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { EditMemberDialogComponent } from '../edit-member-dialog/edit-member-dialog.component';

@Component({
  selector: 'app-content-mobile-cell-renderer',
  imports: [EditMemberDialogComponent],
  templateUrl: './content-mobile-cell-renderer.component.html',
  styleUrl: './content-mobile-cell-renderer.component.scss',
})
export class ContentMobileCellRendererComponent implements ICellRendererAngularComp {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }
}
